import WebIcon from "../../pages/Web/WebIcon";
import { css } from "react-emotion";

const inlineBlock = css`
  display: inline-block;
`;

const StyledToast = (props) => {
  const { message, confirm } = props;
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {" "}
        {confirm && (
          <div style={{ marginRight: "10px" }}>
            {" "}
            <WebIcon
              iconName={"checkMark"}
              useColor={true}
              size={"16px"}
              hover={false}
              className={inlineBlock}
              customColor={"#4caf50"}
            />
          </div>
        )}
        <p>{message}</p>
      </div>
    </div>
  );
};
export default StyledToast;
